import React from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from './Navbar'
import './Dashboard.css'

export default function Dashboard({ setToken }) {
  const navigate = useNavigate()

  const modules = [
    { id: 1, title: 'Lernaufgabe', route: '/learning' },
    { id: 2, title: 'Modul B' },
  ]

  const handleLogout = () => {
    localStorage.removeItem('token')
    setToken(null)
    navigate('/login', { replace: true })
  }

  const handleStatistikClick = () => {
    navigate('/statistik')
  }

  const handleAccountClick = () => {
    navigate('/account')
  }

  const handleModuleClick = (module) => {
    if (module.route) {
      navigate(module.route)
    }
  }

  return (
    <div className="dashboard">
      <div className="background" />
      
      <Navbar 
        title="Wähle ein Modul"
        onLogout={handleLogout}
        logoClickable={false}
        onStatistikClick={handleStatistikClick}
        onAccountClick={handleAccountClick}
      />

      {/* Hauptinhalt mit Padding-Top wegen fixierter Navbar */}
      <div className="dashboard-content">
        <div className="dashboard-container">
          <div className="dashboard-header">
            <h2>Wählen Sie ein Modul</h2>
            <p>Klicken Sie auf ein Modul, um zu beginnen</p>
          </div>
          <div className="dashboard-list">
            {modules.map(m => (
              <div 
                key={m.id} 
                className="dashboard-card"
                onClick={() => handleModuleClick(m)}
                tabIndex={0}
                role="button"
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleModuleClick(m); }}
              >
                <div className="dashboard-card-row dashboard-card-row-top">
                  <div className="dashboard-card-title">{m.title}</div>
                  <div className="dashboard-card-description">Klicken Sie hier, um das Modul zu starten</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}